import React from "react";
import { FormSectionElements, FormSubSections } from "src/entities/formTemplateDataType";
import XMLParser from "../../utilities/XMLParser";
import classNames from 'classnames';
import Utils from "../../utilities/Utils";
import { LiveValidationErrMsg } from "../live-validation-errMsg/LiveValidationErrMsg";
import FormValidationUtils from "../../utilities/FormValidationUtils";
import { getRootComponent } from "../../utilities/ElementUtils";

// Removed: import { Calendar } from "primereact/calendar"; as it's typically for date/datetime.

interface Props {
    field: FormSectionElements;
    editable: boolean;
    title;
    labelControlArray;
    requiredField;
    callbackElement;
    isEng: boolean;
}

interface State {

}

export class TimeComponent extends React.Component<Props, State> {
    
    constructor(props: Props) {
        super(props);
        let field = this.props.field;
        FormValidationUtils.runJavascript(field);
    }
    
    // Updated method name and simplified validation for time
    onTimeChangeOnDialog = (e: React.ChangeEvent<HTMLInputElement>) => {
        let prev = this.props.field.Value;
        // The value for type="time" is a string in "HH:mm" or "HH:mm:ss" format.
        const val = e.target.value; 
        this.props.field.Value = val;
        
       if (!FormValidationUtils.isTime(val)) { 
             this.props.field.Valid = false;
             this.props.field.Touched = true;
        }
        else {
            this.props.field.Valid = true;
        }

        let subSection: FormSubSections = this.props.field.parent as FormSubSections;
    
        this.props.callbackElement(getRootComponent(this.props.field));

        // Validation for comparison is kept, assuming your backend logic handles time comparison
        // or that the stored time format is consistently comparable (e.g., "HH:mm").
        let listCompareFiled = subSection.ListOfFormSectionElements.filter(ele => ele.LoadBindName == this.props.field.ValidateCompareField);
        if(listCompareFiled!=null && listCompareFiled.length>0){
            const comparedTo = listCompareFiled[0];
            // Time comparison: Assumes "HH:mm" strings can be compared lexicographically.
            if(this.props.field.ValidateCompareMethod==">") {
                if(this.props.field.Value<=comparedTo.Value){
                    this.props.field.ErrorMessage = comparedTo.ENUTitle + " must be earlier than " + this.props.field.ENUTitle;
                    this.props.field.Valid = false;
                    this.props.field.Touched=true;
                }
            }
            // Add similar logic for "<" and "==" if needed, ensuring they run after initial validation.
        }


        let listScriptTriggering = subSection.ListOfFormSectionElements.filter(ele => ele.ScriptTriggerField == this.props.field.LoadBindName);
        
        if (listScriptTriggering.length > 0) {
            listScriptTriggering.forEach(ele => {
                // `Utils.getFormattedDate` is likely date-specific. We remove it for time-only components.
                // Assuming `val` is already the value we want to check against `prev`.
                if (ele.Script && prev != val || ele.Value) { 
                    eval(ele.Script);
                    this.props.callbackElement(getRootComponent(this.props.field));
                }
            })
        }

    }

    
    render() {
        let validateCpmpareField;
        let dateValid: boolean = true; // Renamed to `timeValid` might be clearer, but keeping for minimal change.
        let field =  this.props.field;
        if(!field.Visible) return null;
        
        let displayfield: boolean = true;
        let editable = this.props.editable;
        let labelControlArray =this.props.labelControlArray;
        let requiredField =this.props.requiredField;
        let controlArray: React.ReactNode[] = [];
        let title = this.props.title;

        // --- Filter Field Logic remains the same as it checks other form fields ---

        if (this.props.field.FilterField != null) {
            let filterValue;
            let baseName;
            let bindName;
            let parts = this.props.field.FilterField.split('.');
            if (parts.length == 3) {
                baseName = parts[0] + '.' + parts[1];
                bindName = parts[2];
            }
            if (parts.length == 2) {
                baseName = parts[0];
                bindName = parts[1];
            }
            if (parts.length == 1) {
                baseName = '';
                bindName = parts[0];
            }

            let foundFilterFields = XMLParser.extractFormSectionElement(baseName, bindName);

            let foundFilterField;

            if (foundFilterFields && foundFilterFields.length > 0) {
                foundFilterField = foundFilterFields[0];
            }

            if (foundFilterField != null) {
                filterValue = foundFilterField.Value;

                if (filterValue == null || filterValue != null && this.props.field.FilterValue.indexOf(filterValue) == -1 && filterValue.indexOf(this.props.field.FilterValue) == -1) {
                    displayfield = false;
                }
            }
        }
        
        // --- Comparison Validation Logic remains the same, relying on lexicographical comparison of time strings ---

        if (field.ValidateCompareMethod != null) {
            let subSection = this.props.field.parent as FormSubSections;
            let foundValidateCpmpareFieldList = subSection.ListOfFormSectionElements?.filter(p => p.LoadBindName == field.ValidateCompareField);
            if (foundValidateCpmpareFieldList!=null && foundValidateCpmpareFieldList.length > 0) {
                validateCpmpareField = foundValidateCpmpareFieldList[0];
                // Time comparison: Assumes "HH:mm" strings are comparable.
                if (field.ValidateCompareMethod == "<")
                    dateValid = field.Value <= validateCpmpareField.Value;
                else if (field.ValidateCompareMethod == ">") {
                    dateValid = field.Value >= validateCpmpareField.Value;
                } else {
                    dateValid = field.Value == validateCpmpareField.Value;
                }
            }
        }
        let hintHtml = this.props.isEng ? field.Hint : field.HintFR;
        const requiredLabel = this.props.field.Optional == "N" ? this.props.isEng   ? "(required)"   : "(obligatoire)" :  this.props.isEng ? "(optional)" : "(facultatif)"
        // Only render if filter and validation checks pass
        if(!displayfield) return null;

        if (editable) {
            controlArray.push(
                <div key={'div_' + field.Datatype +'_' + field.Id} id= {'div_' + field.Datatype +'_' + field.Id}>
                    <label htmlFor={field.LoadBindName} className="ontario-label"id={field.LoadBindName + "_label"}>{title}
                        <span className='ontario-label__flag'>{title ? requiredLabel : null}</span>{" "} {field.TooltipENU && (<i role='tooltip' title={field.TooltipENU} className="pi pi-info-circle"></i>)}</label>
                        {hintHtml ? <p className="ontario-hint" id={`hint-text-${field.LoadBindName}`} tabIndex={field.Valid ? undefined : -1} dangerouslySetInnerHTML={{ __html: hintHtml }}></p> : null}  
                    <LiveValidationErrMsg
                            field={this.props.field}
                            isEng={this.props.isEng}
                            key={"LiveValidationErrMsg_" +this.props.field.LoadBindName} />

                    {/* KEY CHANGE: Changed type to "time" */}
                    <input
                        type="time" 
                        id={field.LoadBindName} 
                        key={field.Id}
                        name="time" // Updated name
                        className={this.props.field.Valid ?'ontario-input ontario-input--10-char-width':'ontario-input ontario-input--10-char-width ontario-input__error'}
                        maxLength={20} 
                        value={field.Value==null?"":field.Value} // Value will be in "HH:mm" or "HH:mm:ss" format
                        readOnly={field.ReadOnly}
                        onChange={(e) => this.onTimeChangeOnDialog(e)} // Updated handler name
                    />
                </div>
            )
        } else {
            // Display logic for non-editable state - simplified for time
            // Assuming `field.Value` is a time string in "HH:mm" format (e.g., "15:30")
            // No need for Date object conversion for simple time display.
            
            const timeValue = field.Value ? field.Value : '';

            // The original logic used `new Date(field.Value)` which works for datetime strings,
            // but is overly complex and potentially error-prone for time-only strings.
            // A simple display of the stored value is sufficient for "time" input type.

            controlArray.push(
                <div key={'div_display_' + field.Id} className='pdf-two-column'>
                    <div>{title}</div>
                    <div className={classNames({ 'invalid-field--highlighted': (this.props.field.Value == '' || this.props.field.Value == null) && requiredField })} >
                        {/* Display the time value directly */}
                        {timeValue}
                    </div>
                </div>
            );
            
        }

        return controlArray;
    }

}